import { __assign, __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { LegendLabelView } from './legend-label-view';
import { CheckboxGroup } from '../../composites/checkbox-group';
import { DeprecatedText } from '../../deprecated-typography';
import { ActionsMenuButton } from '../../composites';
export var ChartLegendKey = 'chart-legend';
var ChartLegend = /** @class */ (function (_super) {
    __extends(ChartLegend, _super);
    function ChartLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.minVisibleLabels = 1;
        _this.maxVisibleLabels = 8;
        _this.state = {
            visibleLegendLabels: _this.props.labels.slice(0, _this.maxVisibleLabels),
            isMoreLabelsOpen: false,
        };
        _this.onLabelClick = function (labelId) { return function (labelValue) {
            var _a;
            var value = __assign(__assign({}, _this.props.value), (_a = {}, _a[labelId] = labelValue, _a));
            _this.props.onChange(value);
        }; };
        _this.renderVisibleLegendLabels = function () {
            var value = _this.props.value;
            var isSingleLabelSelected = Object.keys(value).reduce(function (res, curr) { return !!value[curr] ? res + 1 : res; }, 0) === 1;
            return _this.state.visibleLegendLabels.map(function (label) {
                var isSelected = _this.props.value[label.id];
                return (React.createElement(LegendLabelView, { key: label.id, value: _this.props.value[label.id], onChange: _this.onLabelClick(label.id), label: label, disabled: isSelected && isSingleLabelSelected }));
            });
        };
        _this.onVisibleLegendLabelsChange = function (map) {
            var updatedVisibleLabels = _this.props.labels.filter(function (l) { return map.get(l.id) === true; });
            var maybeLastVisibleLabel = updatedVisibleLabels.length === 1 ? updatedVisibleLabels[0] : null;
            var updatedValue = _this.props.labels.reduce(function (res, curr) {
                var _a;
                var maybeCurrentlyVisibleLabel = _this.state.visibleLegendLabels.find(function (l) { return l.id === curr.id; });
                var isRemovingLabel = maybeCurrentlyVisibleLabel && map.get(curr.id) === false;
                var isAddingLabel = !maybeCurrentlyVisibleLabel && map.get(curr.id) === true;
                var isLastVisibleLabel = maybeLastVisibleLabel && maybeLastVisibleLabel.id === curr.id;
                return __assign(__assign({}, res), (_a = {}, _a[curr.id] = isRemovingLabel ? false : isAddingLabel ? true : (isLastVisibleLabel || _this.props.value[curr.id]), _a));
            }, {});
            _this.setState({ visibleLegendLabels: updatedVisibleLabels });
            _this.props.onChange(updatedValue);
        };
        _this.toggleMoreLabels = function (visible) { return function () { return _this.setState({ isMoreLabelsOpen: visible }); }; };
        _this.createCheckboxItems = function () {
            return _this.props.labels.map(function (label) { return ({
                id: label.id,
                label: label.name,
                customElement: React.createElement(DeprecatedText, null, label.name)
            }); });
        };
        return _this;
    }
    ChartLegend.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.labels.length <= this.maxVisibleLabels) {
            var visibleLegendLabels = nextProps.labels;
            this.setState({ visibleLegendLabels: visibleLegendLabels });
        }
    };
    ChartLegend.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var classNames = namespacedClassnames(ChartLegendKey, props.className);
        var allCheckboxesEntries = props.labels.reduce(function (res, curr) {
            var isCurrentVisible = !!_this.state.visibleLegendLabels.find(function (l) { return l.id === curr.id; });
            return __spreadArrays(res, [[curr.id, isCurrentVisible]]);
        }, []);
        var items = this.createCheckboxItems();
        var value = new Map(allCheckboxesEntries);
        var checkboxGroup = (React.createElement(CheckboxGroup, { value: value, items: items, onChange: this.onVisibleLegendLabelsChange, maxSelections: this.maxVisibleLabels, minSelections: this.minVisibleLabels, t: props.t }));
        var maybeLegendLabelsDropdown = this.props.labels.length > 8 ? (React.createElement(ActionsMenuButton, { preferPlace: 'above' }, checkboxGroup)) : null;
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'visible-labels-wrapper' }, this.renderVisibleLegendLabels()),
            maybeLegendLabelsDropdown));
    };
    return ChartLegend;
}(React.PureComponent));
export { ChartLegend };
//# sourceMappingURL=index.js.map